<template>
  <div class="field">
    <label> {{division.label}} </label>
    <div>
      <select v-model="division.count" @change="changed">
        <option
          v-for="option in options"
          :value="option.value"
          :key="option.value"
        >
          {{ option.string }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
import { ref } from "vue";

export default {
  name: "selectDivisionSeatCountForm",
  props: {
    division:{
      type: Object,
      require: true
    },
    changed:{
      type: Function,
      require: true
    }
  },
  setup(props) {
    const vmodel = useVModel(props, "division");
    const options = ref([
      { value: 0, string: "0名" },
      { value: 1, string: "1名" },
      { value: 2, string: "2名" },
      { value: 3, string: "3名" },
      { value: 4, string: "4名" },
      { value: 5, string: "5名" },
      { value: 6, string: "6名" },
      { value: 7, string: "7名" },
      { value: 8, string: "8名" }
    ])
    return{
      options
    }
  },
};
</script>

<style scoped lang="scss">

.field {
  position: relative;
  margin: auto;
  width: 95%;
  padding-bottom: 10px;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

select {
  -webkit-appearance: none;
  width: 100%;
  height: 38px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 150px;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

select:disabled {
  border-color: #e0e0e0;
  background-color: #f0f0f0;
}
</style>
